function extractModuleConfig(payload = {}) {
  if (payload?.modules || payload?.moduleConfig || payload?.features) {
    return {
      modules: payload.modules || payload.moduleConfig || payload.features || {},
    };
  }

  const directModuleEntries = Object.entries(payload).filter(([, value]) => {
    return typeof value === 'boolean' || (value && typeof value.enabled === 'boolean');
  });

  if (directModuleEntries.length > 0) {
    return {
      modules: Object.fromEntries(directModuleEntries),
    };
  }

  return {
    modules: {},
  };
}

function getModuleEntry(state, moduleKey) {
  return state.config?.modules?.[moduleKey];
}

export default {
  namespaced: true,

  state: () => ({
    config: {
      modules: {},
    },
  }),

  getters: {
    config: (state) => state.config,

    isModuleEnabled: (state) => (moduleKey, defaultEnabled = true) => {
      const entry = getModuleEntry(state, moduleKey);

      if (typeof entry === 'boolean') return entry;
      if (entry && typeof entry.enabled === 'boolean') return entry.enabled;

      return defaultEnabled;
    },
  },

  mutations: {
    SET_CONFIG(state, config) {
      state.config = extractModuleConfig(config);
    },

    RESET_STATE(state) {
      state.config = {
        modules: {},
      };
    },
  },

  actions: {
    hydrateFromMerchant({ commit }, merchant = {}) {
      commit('SET_CONFIG', merchant);
    },

    resetState({ commit }) {
      commit('RESET_STATE');
    },
  },
};
